import React from 'react';

export const DAY_SHIFT_OPTIONS = [
  { value: '06:00-13:00', label: '6:00 AM - 1:00 PM' },
  { value: '06:30-15:30', label: '6:30 AM - 3:30 PM' },
  { value: '07:00-16:00', label: '7:00 AM - 4:00 PM' },
  { value: '07:30-16:30', label: '7:30 AM - 4:30 PM' },
  { value: '08:00-17:00', label: '8:00 AM - 5:00 PM' },
  { value: '08:30-17:30', label: '8:30 AM - 5:30 PM' },
  { value: '09:00-18:00', label: '9:00 AM - 6:00 PM' },
  { value: '09:30-18:30', label: '9:30 AM - 6:30 PM' },
  { value: '10:00-19:00', label: '10:00 AM - 7:00 PM' },
  { value: '10:30-19:30', label: '10:30 AM - 7:30 PM' },
  { value: '11:00-20:00', label: '11:00 AM - 8:00 PM' },
  { value: '11:30-20:30', label: '11:30 AM - 8:30 PM' },
  { value: '12:00-21:00', label: '12:00 PM - 9:00 PM' },
  { value: '12:30-21:30', label: '12:30 PM - 9:30 PM' },
];

export const NIGHT_SHIFT_OPTIONS = [
  { value: '13:00-22:00', label: '1:00 PM - 10:00 PM' },
  { value: '13:30-22:30', label: '1:30 PM - 10:30 PM' },
  { value: '14:00-23:00', label: '2:00 PM - 11:00 PM' },
  { value: '14:30-23:30', label: '2:30 PM - 11:30 PM' },
  { value: '15:00-00:00', label: '3:00 PM - 12:00 AM' },
  { value: '15:30-00:30', label: '3:30 PM - 12:30 AM' },
  { value: '16:00-01:00', label: '4:00 PM - 1:00 AM' },
  { value: '16:30-01:30', label: '4:30 PM - 1:30 AM' },
  { value: '17:00-02:00', label: '5:00 PM - 2:00 AM' },
  { value: '17:30-02:30', label: '5:30 PM - 2:30 AM' },
  { value: '18:00-03:00', label: '6:00 PM - 3:00 AM' },
  { value: '18:30-03:30', label: '6:30 PM - 3:30 AM' },
  { value: '19:00-04:00', label: '7:00 PM - 4:00 AM' },
  { value: '19:30-04:30', label: '7:30 PM - 4:30 AM' },
  { value: '20:00-05:00', label: '8:00 PM - 5:00 AM' },
  { value: '20:30-05:30', label: '8:30 PM - 5:30 AM' },
  { value: '21:00-06:00', label: '9:00 PM - 6:00 AM' },
  { value: '21:30-06:30', label: '9:30 PM - 6:30 AM' },
  { value: '22:00-07:00', label: '10:00 PM - 7:00 AM' },
  { value: '22:30-07:30', label: '10:30 PM - 7:30 AM' },
  { value: '23:00-08:00', label: '11:00 PM - 8:00 AM' },
  { value: '23:30-08:30', label: '11:30 PM - 8:30 AM' },
  { value: '00:00-09:00', label: '12:00 AM - 9:00 AM' },
  { value: '00:30-09:30', label: '12:30 AM - 9:30 AM' },
  { value: '01:00-10:00', label: '1:00 AM - 10:00 AM' },
  { value: '01:30-10:30', label: '1:30 AM - 10:30 AM' },
  { value: '02:00-11:00', label: '2:00 AM - 11:00 AM' },
  { value: '02:30-11:30', label: '2:30 AM - 11:30 AM' },
  { value: '03:00-12:00', label: '3:00 AM - 12:00 PM' },
  { value: '03:30-12:30', label: '3:30 AM - 12:30 PM' },
  { value: '04:00-13:00', label: '4:00 AM - 1:00 PM' },
  { value: '04:30-13:30', label: '4:30 AM - 1:30 PM' },
  { value: '05:00-14:00', label: '5:00 AM - 2:00 PM' },
  { value: '05:30-14:30', label: '5:30 AM - 2:30 PM' },
];

const ALL_SHIFT_OPTIONS = [...DAY_SHIFT_OPTIONS, ...NIGHT_SHIFT_OPTIONS];

function normalizeShiftValue(shiftValue) {
  return String(shiftValue || '')
    .trim()
    .replace(/\s+/g, '')
    .replace(/[–—]/g, '-');
}

export function getShiftLabel(shiftValue) {
  if (!shiftValue) return '—';
  const normalized = normalizeShiftValue(shiftValue);
  const match = ALL_SHIFT_OPTIONS.find((opt) => opt.value === normalized);
  return match ? match.label : formatShiftRange12h(normalized);
}

function formatShiftRange12h(shift) {
  if (!shift || !String(shift).includes('-')) return shift || '—';
  const formatPart = (part) => {
    const [h, m] = part.split(':').map((v) => parseInt(v, 10));
    if (Number.isNaN(h)) return part;
    const period = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 || 12;
    const mins = Number.isNaN(m) ? 0 : m;
    return `${hour12}:${String(mins).padStart(2, '0')} ${period}`;
  };
  const [start, end] = String(shift).split('-').map((s) => s.trim());
  return `${formatPart(start)} - ${formatPart(end)}`;
}

export function ShiftScheduleOptions() {
  return (
    <>
      <optgroup label="Day Shift">
        {DAY_SHIFT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </optgroup>
      <optgroup label="Night Shift">
        {NIGHT_SHIFT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </optgroup>
    </>
  );
}
